import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { InputBase } from '@mui/material';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import {
	SetFormState, DeleteSite, ToggleDeleteSiteTrackerDialog, GetSites
} from '../../../actions/SiteTrackerActions';

const SiteTrackerDeleteDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.siteTrackerReducer.tableId);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const _onConfirmClick = () => {
		dispatch(DeleteSite(userId, tableId));
		dispatch(ToggleDeleteSiteTrackerDialog(false));
		dispatch(GetSites(userId, role));
		dispatch(enqueueSnackbar({ message: 'Site deleted', options: { variant: 'info' } }));
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Delete site"
			confirmLabel="Ok"
			onConfirmClicked={_onConfirmClick}
		>
			<InputBase
				// className={classes.margin}
				defaultValue="Do you want to delete this site?"
				inputProps={{ 'aria-label': 'naked' }}
				fullWidth
			/>
		</ModalDialog>
	);
};

SiteTrackerDeleteDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default SiteTrackerDeleteDialog;
